import { motion } from "framer-motion";

const ARTIST_PHOTO = "/images/teledysk/about-artist.jpg";

export default function AboutArtist() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-32 bg-[#192D48]/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
        >
          <h2
            className="font-['Oswald'] text-3xl md:text-4xl font-bold uppercase tracking-tighter mb-2"
            data-testid="about-section-title"
          >
            O artyście
          </h2>
          <div className="w-16 h-[2px] bg-[#EB0023] mb-12" />
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Photo */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8 }}
            className="relative group overflow-hidden"
          >
            <div className="absolute -inset-1 bg-gradient-to-br from-[#EB0023]/20 to-[#32558B]/20 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            <img
              src={ARTIST_PHOTO}
              alt="Pueblo"
              data-testid="about-artist-photo"
              className="w-full aspect-square object-cover grayscale hover:grayscale-0 transition-all duration-700"
              loading="lazy"
            />
          </motion.div>

          {/* Bio text */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="flex flex-col gap-6"
          >
            <p className="font-['Manrope'] text-base md:text-lg text-[#A0B0C4] leading-relaxed">
              Pueblo — undergroundowy raper znany w Poznaniu z freestylu wypuszcza swój pierwszy album łączący emocje, mocne brzmienie i szczery przekaz w swoim własnym stylu.
            </p>
            <div className="mt-4">
              <span className="font-['Oswald'] text-2xl md:text-3xl uppercase tracking-tighter text-white">
                PIĄTKOWO.
              </span>
              <span className="font-['Oswald'] text-2xl md:text-3xl uppercase tracking-tighter text-[#EB0023] ml-2">
                UNDERGROUND.
              </span>
              <span className="font-['Oswald'] text-2xl md:text-3xl uppercase tracking-tighter text-[#32558B] ml-2">
                TRAP.
              </span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
